import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrivacyPage = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy — Searchefy</title>
        <meta name="description" content="Searchefy Privacy Policy. Learn how we collect, use, and protect your data." />
        <link rel="canonical" href="https://searchefy.com/privacy" />
      </Helmet>

      <div data-testid="privacy-page" className="min-h-screen bg-[#F9FAFB]">
        <Navbar />
        <main className="pt-24 pb-24">
          <div className="max-w-3xl mx-auto px-6 md:px-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h1 className="font-display text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
              
              <div className="prose prose-gray max-w-none">
                <p className="text-gray-600 mb-6">Last updated: December 2025</p>
                
                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Information We Collect</h2>
                <p className="text-gray-600 mb-4">
                  When you create an account or make a purchase, we collect:
                </p>
                <ul className="list-disc pl-6 text-gray-600 mb-6">
                  <li>Email address</li>
                  <li>Payment information (processed securely by Dodo Payments)</li>
                  <li>Usage data within the application</li>
                </ul>

                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">How We Use Your Information</h2>
                <p className="text-gray-600 mb-4">
                  We use your information to:
                </p>
                <ul className="list-disc pl-6 text-gray-600 mb-6">
                  <li>Provide and maintain our service</li>
                  <li>Process transactions</li>
                  <li>Send important updates about your account</li>
                  <li>Improve our platform</li>
                </ul>

                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Data Security</h2>
                <p className="text-gray-600 mb-6">
                  We implement industry-standard security measures to protect your data. Payment information is handled exclusively by our payment processor and is never stored on our servers.
                </p>

                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Third-Party Services</h2>
                <p className="text-gray-600 mb-6">
                  We use third-party services for payment processing (Dodo Payments) and analytics. These services have their own privacy policies.
                </p>

                <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Contact Us</h2>
                <p className="text-gray-600">
                  If you have questions about this Privacy Policy, contact us at{' '}
                  <a href="mailto:thepratishjain@gmail.com" className="text-blue-600 hover:underline">
                    thepratishjain@gmail.com
                  </a>
                </p>
              </div>
            </motion.div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default PrivacyPage;
